'use client';

import { visualStyle as style } from './visual.style';
import Image from 'next/image';
import { SwiperContainer } from '@/components/containers/swiper-container';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useTemplateResourceContext } from '../context/template-resource-context';

export const Visual = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const templateResourceContext = useTemplateResourceContext();
	const { templateResource, isSuccess } = templateResourceContext;
	
	return (
		<section data-name="visual" className={style.visual}>
			{
				isSuccess&&
				<SwiperContainer
					slideElements={templateResource!.VisualResources!.map(item => {
						const { Src } = item;
						return (
							<Image
								key={`${Src}`}
								src={`${SiteConfigsData?.ImageServerUrl}${Src}`}
								width={1920}
								height={485}
								alt=""
							/>
						)
					})}
					customProps={{
						navigation: { enabled: true },
						pagination: { enabled: true },
						allowTouchMove: true,
						loop: true,
						autoplay: {
							delay: 5000,
							disableOnInteraction: false
						},
					}}
				/>
			}
			
		</section>
	)
}